import { render, staticRenderFns } from "./DialongRemark.vue?vue&type=template&id=22063336&scoped=true&"
import script from "./DialongRemark.vue?vue&type=script&lang=js&"
export * from "./DialongRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22063336",
  null
  
)

export default component.exports